import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DialogCloseRef {
  private readonly subject = new BehaviorSubject<string>('');
  readonly close$ = this.subject.asObservable();

  close(testId: string): void {
    this.subject.next(testId);
  }
}
